<div class="container single-view" id="view-shipment">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/shipments" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'SHIPMENTS.BTN_BACK_TO_SHIPMENT' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="shipment-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'SHIPMENT_SINGLE_VIEW.SHIPMENT_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (shipmentData.name) {
                  <span data-testid="shipment-name">
                    {{ shipmentData.name | defaultValue }}
                  </span>
                }
                @if (shipmentData.isCancelled) {
                  <span data-testid="shipment-iscancelled" class="tag tag-red">
                    {{ 'SHIPMENT_SINGLE_VIEW.CANCELLED' | translate }}
                  </span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 mt-2">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='shipment-createdon' class="flex items-center mr-2" pTooltip="{{ 'SHIPMENT_SINGLE_VIEW.CREATED_ON' | translate }}" tooltipPosition="top"><i class="icon icon-calendar mr-1"></i>{{ shipmentData.createdOn | date: 'dd-MM-yyyy HH:mm' }}</span>
            <span data-testid='shipment-createdby' class="flex items-center mr-2" pTooltip="{{ 'SHIPMENT_SINGLE_VIEW.CREATED_BY' | translate }}" tooltipPosition="top"><i class="icon icon-user mr-1"></i>
              @if (shipmentData.createdById && allowViewUser) {
                <a [routerLink]="['/users/', shipmentData.createdById]" class="inline-flex items-center link">
                  {{ shipmentData.createdByFullName | defaultValue }}
                </a>
              } @else {
                {{ shipmentData.createdByFullName | defaultValue }}
              }
            </span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyShipment) {
              <button data-testid="shipment-add-items-btn" [disabled]="shipmentData.isCancelled || shipmentData.isReceived" class="btn outline-btn" (click)="addShipmentItems()">
                {{ 'SHIPMENT_SINGLE_VIEW.BTN_ADD_SHIPMENT_ITEMS' | translate }}
              </button>

              <button data-testid="shipment-revalidate-items-btn" [disabled]="shipmentData.isCancelled || !shipmentData.shipmentItems || shipmentData.isReceived" class="btn outline-btn" (click)="revalidateShipmentItems()">
                {{ 'SHIPMENT_SINGLE_VIEW.BTN_REVALIDATE_ITEMS' | translate }}
              </button>

              <button data-testid="shipment-edit-btn" [disabled]="shipmentData.isCancelled || shipmentData.isReceived" class="btn primary-btn" (click)="goToEditShipment()">
                {{ 'SHIPMENT_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>

              <button data-testid="shipment-cancel-btn" [disabled]="shipmentData.isCancelled || shipmentData.isReceived" class="btn primary-btn" (click)="cancelShipment()">
                {{ 'SHIPMENT_SINGLE_VIEW.BTN_CANCEL' | translate }}
              </button>
            }

            @if (delete) {
              <button data-testid="shipment-delete-btn" [disabled]="shipmentData.isReceived" id="btn-delete-shipment" class="btn red-btn" (click)="showDeleteDialog()">
                {{ 'SHIPMENTS.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='shipment-details'>{{ 'SHIPMENT_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid='shipment-retailer-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.RETAILER' | translate }}</dt>
                  <dd data-testid='shipment-retailer' class="value pt-3 pb-3">
                    @if (shipmentData.retailerId && allowViewRetailer) {
                      <a [routerLink]="['/retailers/', shipmentData.retailerId]" class="inline-flex items-center link">
                        {{ shipmentData.retailerName }}
                      </a>
                    } @else {
                      {{ shipmentData.retailerName }}
                    }
                  </dd>

                  <dt data-testid='shipment-origin-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.SHIPMENT_ORIGIN' | translate }}</dt>
                  <dd data-testid='shipment-origin' class="value pt-3 pb-3">
                    @if (shipmentData.originRetailerId && allowViewRetailer) {
                      <a [routerLink]="['/retailers/', shipmentData.originRetailerId]" class="inline-flex items-center link">
                        {{ shipmentData.originRetailerName ?? shipmentData.originRetailerId }}
                      </a>
                    } @else {
                      {{ shipmentData.originRetailerName ?? shipmentData.originRetailerId }}
                    }
                  </dd>

                  <dt data-testid='shipment-destination-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.SHIPMENT_DESTINATION' | translate }}</dt>
                  <dd data-testid='shipment-destination' class="value pt-3 pb-3">
                    @if (shipmentData.destinationRetailerId && allowViewRetailer) {
                      <a
                        [routerLink]="['/retailers/', shipmentData.destinationRetailerId]"
                        class="inline-flex items-center link">
                        {{ shipmentData.destinationRetailerName ?? shipmentData.destinationRetailerId }}
                      </a>
                    } @else {
                      {{ shipmentData.destinationRetailerName ?? shipmentData.destinationRetailerId }}
                    }
                  </dd>

                  <dt data-testid='shipment-comment-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.SHIPMENT_COMMENTS' | translate }}</dt>
                  <dd data-testid='shipment-comment' class="value pt-3 pb-3">{{ shipmentData.comment | defaultValue }}</dd>

                  <dt data-testid='shipment-updatedon-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.UPDATED_ON' | translate }}</dt>
                  <dd data-testid='shipment-updatedon' class="value pt-3 pb-3">{{ shipmentData.updatedOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</dd>

                  <dt data-testid='shipment-updatedby-label' class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.UPDATED_BY' | translate }}</dt>
                  <dd data-testid='shipment-updatedby' class="value pt-3 pb-3">
                    @if (shipmentData.updatedById && allowViewUser) {
                      <a [routerLink]="['/users/', shipmentData.updatedById]" class="inline-flex items-center link">
                        {{ shipmentData.updatedByFullName | defaultValue }}
                      </a>
                    } @else {
                      {{ shipmentData.updatedByFullName | defaultValue }}
                    }
                  </dd>
                    @if (shipmentData.isCancelled) {
                      <dt data-testid="shipment-cancelationreason-label" class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.CANCEL_REASON' | translate }}</dt>
                      <dd data-testid="shipment-cancelationreason" class="value pt-3 pb-3">{{ shipmentData.cancelationReason | defaultValue }}</dd>
                    }
                </dl>
              </div>
            </section>
            @if (shipmentData.shipmentItems) {
              <section class="row">
                <div class="col-12 mb-3">
                  <h4 data-testid='shipment-items'>{{ 'SHIPMENT_SINGLE_VIEW.ITEMS_IN_SHIPMENT' | translate }} ({{ shipmentData.totalItems }})</h4>
                  <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                </div>
                <div class="col-12">
                  <p-table [value]="paginatedItems">
                    <ng-template #header>
                      <tr>
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-0"  class="col-name">{{ 'SHIPMENT_SINGLE_VIEW.TH_SERIAL_NUMBER' | translate }}</span>
                          </div>
                        </th>
                        @if (companyHasCpo) {
                          <th>
                            <div class="header-wr">
                              <span data-testid="table-header-2" class="col-name">
                                {{ 'SHIPMENT_SINGLE_VIEW.TH_IS_CPO' | translate }}
                              </span>
                            </div>
                          </th>
                        }
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-4"  class="col-name">{{ 'SHIPMENT_SINGLE_VIEW.TH_STATUS' | translate }}</span>
                          </div>
                        </th>
                        <th>
                          <div class="header-wr">
                            <span data-testid="table-header-actions"  class="col-name">{{ 'SHIPMENT_SINGLE_VIEW.TH_ACTIONS' | translate }}</span>
                          </div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-shipmentItem let-rowIndex="rowIndex">
                      <tr [attr.data-id]="shipmentItem.id">
                        <td>
                          <span class="p-column-title">{{ 'SHIPMENT_SINGLE_VIEW.TH_SERIAL_NUMBER' | translate }}:</span>
                          <span [attr.data-testid]="'cell-0-' + rowIndex">{{ shipmentItem.serialNumber | defaultValue }}</span>
                        </td>
                        @if (companyHasCpo) {
                          <td>
                            <span class="p-column-title">{{ 'SHIPMENT_SINGLE_VIEW.TH_IS_CPO' | translate }}:</span>
                            <span [attr.data-testid]="'cell-2-' + rowIndex">
                              {{ shipmentItem.isCpo | friendlyBoolean }}
                            </span>
                          </td>
                        }
                        <td>
                          <span class="p-column-title">{{ 'SHIPMENT_SINGLE_VIEW.TH_STATUS' | translate }}:</span>
                          <span [attr.data-testid]="'cell-4-' + rowIndex" class="tag"
                            [ngClass]="{
                              'tag-green': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_EXISTS,
                              'tag-red': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_DOES_NOT_EXIST,
                              'tag-orange': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_IS_NOT_VALID,
                              'tag-blue': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_REVIEW,
                              'tag-gray': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_STOLEN,
                              'tag-yellow': shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_SOLD
                            }">{{ shipmentItem.state | shipmentItemState }}</span>
                        </td>
                        <td class="actions-col">
                          <div class="actions gap-2">
                            @if (allowModifyShipment && shipmentItem.state === shipmenItemState.SHIPMENT_ITEM_REVIEW) {
                              <button data-testid="shipment-item-view-detail-btn" [disabled]="shipmentData.isCancelled || shipmentData.isReceived" type="button" pTooltip="{{ 'SHIPMENTS.TOOLTIP_VIEW_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-eye" (click)="viewShipmentItemDetails($event, shipmentItem.serialNumber, shipmentItem.id)" [attr.data-testid]="'btn-view-' + rowIndex">
                                <span class="btn-label">
                                  {{ 'SHIPMENTS.VIEW_SHIPMENT_ITEM_DETAILS' | translate }}
                                </span>
                              </button>
                            }
                            @if (allowModifyShipment) {
                              <button [disabled]="shipmentData.isCancelled || shipmentData.isReceived" type="button" pTooltip="{{ 'SHIPMENT_SINGLE_VIEW.REMOVE_ITEM' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-view btn-icon icon-remove" (click)="onRemoveItemFromShipment($event, shipmentItem.id)" [attr.data-testid]="'btn-remove-' + rowIndex">
                                <span class="btn-label">
                                  {{ 'SHIPMENT_SINGLE_VIEW.REMOVE_ITEM' | translate }}
                                </span>
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                      <tr>
                        <td [attr.colspan]="!shipmentData.shipmentItems || 6">{{ 'SHIPMENT_SINGLE_VIEW.NO_DATA' | translate }}</td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <!-- Pagination -->
                  <app-custom-paginator
                    data-testid="paginator"
                    [pageNumber]="paginatorPageNumber"
                    [rows]="paginatorRows"
                    [totalRecords]="totalRecords"
                    [rowsPerPageOptions]="[10, 20, 30]"
                    [showCurrentPageReport]="true"
                    [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                    [disabled]="!totalRecords"
                    [alwaysShow]="true"
                    [showFirstLastIcon]="true"
                    [showPageLinks]="true"
                    [showPageSizeSelector]="true"
                    (onPageChange)="onPageChange($event)">
                  </app-custom-paginator>
                </div>
              </section>
            }
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modalbox: add item to inventory -->
<p-dialog
  [(visible)]="displayAddItemsModalbox"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeOnEscape]="true"
  appendTo="body"
  [contentStyle]="{ height: '50vh', minHeight: '400px', padding: '0' }"
  styleClass="shipment-scanner-dialog"
  (onShow)="onScannerDialogShow()"
  (onHide)="onScannerDialogHide()">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full ">
      <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_ADD_SHIPMENT_ITEMS' | translate }}</span>
    </div>
  </ng-template>

  @if (scannerMounted) {
    <app-multi-scanner
      #multiScanner
      [title]="'MODALBOXES.TITLE_ADD_SHIPMENT_ITEMS' | translate"
      [autoStart]="true"
      [initialItems]="scannerInitialItems"
      [allowDuplicateScans]="false"
      [showCameraSelector]="true"
      [startDrawerOpen]="false"
      [openDrawerOnScan]="false"
      captureTemplateName="ReadSingleBarcode"
      (itemsChange)="onScannerItemsChange($event)"
      (finishScanning)="onScannerFinish($event)"
      (scannerClosed)="requestScannerModalClose()"
      (scannerError)="onScannerError($event)">
    </app-multi-scanner>
  }
</p-dialog>

<!-- Modalbox: prompt confirm leaving without finish scanning -->
<p-dialog [(visible)]="displayUnsavedScannerItemsModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" appendTo="body">
  <ng-template pTemplate="header">
    <span class="p-dialog-title">{{ 'MODALBOXES.TITLE_UNSAVED_SCANNER_ITEMS' | translate }}</span>
  </ng-template>
  <p data-testid="unsaved-scanner-items-message" class="text-base">{{
    'MODALBOXES.DESCRIPTION_UNSAVED_SCANNER_SHIPMENT_ITEMS_AFTER_CLOSE' | translate }}</p>
  <ng-template #footer>
    <button data-testid="unsaved-scanner-items-dismiss-btn" type="button" class="btn outline-btn"
      (click)="dismissUnsavedScannerItems()">
      {{ 'MODALBOXES.BTN_DISCARD_SCANNER_ITEMS' | translate }}
    </button>
    <button data-testid="unsaved-scanner-items-save-btn" type="button" class="btn primary-btn"
      (click)="saveUnsavedScannerItems()">
      {{ 'MODALBOXES.BTN_SAVE_SCANNER_ITEMS' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modalbox: shipment item removal -->
<p-dialog [header]="'MODALBOXES.TITLE_REMOVE_ITEM_FROM_SHIPMENT' | translate" [(visible)]="displayRemoveItemConfirmationModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <p data-testid="item-remove-text" class="text-base" [innerHTML]="'MODALBOXES.DESCRIPTION_REMOVE_ITEM_FROM_SHIPMENT' | translate"></p>
  <ng-template #footer>
    <button data-testid="item-remove-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelItemRemoval()">{{ 'MODALBOXES.BTN_CANCEL_REMOVE_SHIPMENT_ITEM' |
      translate }}</button>
    <button data-testid="item-remove-submit-btn" type="button" class="btn primary-btn" (click)="onConfirmItemRemoval()">{{
      'MODALBOXES.BTN_REMOVE_SHIPMENT_ITEM' | translate }}</button>
  </ng-template>
</p-dialog>

<!-- Modalbox: cancel shipment -->
<p-dialog [header]="'MODALBOXES.TITLE_CANCEL_SHIPMENT' | translate" [(visible)]="displayCancelShipmentModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" class="compact-modal">
  <form [formGroup]="cancelShipmentForm" (ngSubmit)="onSubmitCancelShipmentForm()" class="mt-0">
    <div class="field-wr flex flex-col col-12">
      <label data-testid="cancel-shipment-reason-label" class="block text-sm" for="reason">{{ 'SHIPMENT_SINGLE_VIEW.CANCEL_REASON' | translate }}<i
          class="icon-required-field"></i></label>
      <input data-testid="cancel-shipment-reason"  type="text" formControlName="reason" autocomplete="off">
      @if (
        cancelShipmentForm.get('reason')?.invalid &&
        (cancelShipmentForm.get('reason')?.dirty || cancelShipmentForm.get('reason')?.touched)
      ) {
        @if (cancelShipmentForm.get('reason')?.hasError('required')) {
          <small data-testid="reason-mandatory" class="p-error">
            {{ 'FORMS.MANDATORY_FIELD' | translate }}
          </small>
        }

        @if (cancelShipmentForm.get('reason')?.hasError('maxlength')) {
          <small data-testid="reason-length-error" class="p-error">
            {{ 'FORMS.FIELD_LENGTH_EXCEEDED' | translate }}
          </small>
        }
      }
    </div>
  </form>

  <ng-template #footer>
    <button data-testid="cancel-shipment-cancel-btn" type="button" class="btn outline-btn" (click)="onCancelCancelShipmentModal()">
      {{ 'MODALBOXES.BTN_CANCEL_CANCEL_SHIPMENT' | translate }}
    </button>
    <button data-testid="cancel-shipment-submit-btn" type="submit" class="btn primary-btn" [disabled]="cancelShipmentForm.invalid"
      (click)="onSubmitCancelShipmentForm()">
      {{ 'MODALBOXES.BTN_CONFIRM_CANCEL_SHIPMENT' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modalbox: shipment item review-->
 <p-dialog [header]="'MODALBOXES.TITLE_REVIEW_SHIPMENT_ITEM_DETAILS' | translate"
  [(visible)]="displayShipmentItemDetailsModalbox" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
  <p class="text-base" [innerHTML]="'MODALBOXES.DESCRIPTION_REVIEW_ITEM' | translate"></p>

  @if (inMemoryPagedResults.length) {
    <section class="row pb-6">
      <!-- Product results -->
      <ul id="product-results" class="mb-2">
        @for (item of inMemoryPagedResults; track item; let last = $last; let count = $count) {

          <li class="product-item row mt-3 mb-3" [attr.product-id]="item.product?.id" [ngClass]="{ 'border-b pb-6': count > 1 && !last }">
            <div class="col-12 col-sm-12 col-md-4 col-lg-3">
              <img [src]="item._customisation?.imageUrl || item.product?.imageUrl || item.product?.productType?.imageUrl" class="w-100 mt-2 featured-image"/>
            </div>

            <!-- DETAILS -->
            <div class="col-12 col-sm-12 col-md-8 col-lg-9">
              <dl class="details-grid">
                <dt data-testid="review-product-name-label" class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.PRODUCT_NAME' | translate }}</dt>
                <dd data-testid="review-product-name" class="value pt-3 pb-3">{{ item.product?.name }}</dd>

                <dt data-testid="review-product-serialnumber-label" class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.SERIAL_NUMBER' | translate }}</dt>
                <dd data-testid="review-product-serialnumber" class="value pt-3 pb-3">{{ item.serialNumber }}</dd>

                <dt data-testid="review-product-sku-label" class="label grid-cols-1 pt-3">{{ 'SHIPMENT_SINGLE_VIEW.REFERENCE' | translate }}</dt>
                <dd data-testid="review-product-sku" class="value pt-3 pb-3">{{ item.product?.sku | defaultValue }}</dd>
              </dl>

              <div class="row mt-3">
                <div class="col-4">
                  <button data-testid="review-select-btn" class="btn outline-btn w-full" (click)="onSelectItem(item.id)">
                    {{ 'SHIPMENT_SINGLE_VIEW.SELECT_PRODUCT' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>

      <!-- Paginator -->
      @if (inMemoryTotalRecords > 0) {
        <app-custom-paginator
          data-testid="products-paginator"
          [first]="inMemoryPaginator.first"
          [rows]="inMemoryPaginator.rows"
          [totalRecords]="inMemoryTotalRecords"
          [rowsPerPageOptions]="[inMemoryPaginator.rows]"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
          [disabled]="inMemoryTotalRecords === 0"
          [alwaysShow]="true"
          [showFirstLastIcon]="true"
          [showPageLinks]="true"
          [showPageSizeSelector]="false"
          (onPageChange)="onInMemoryPageChange($event)">
        </app-custom-paginator>
      }

      <!-- /Product results -->
    </section>
  }
</p-dialog>

<!-- Delete shipment -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_SHIPMENT'" (onClose)="deleteShipment($event)"></dialog-reason>
